import DivideForm from './steps/DivideForm';
import MapQuestions from './steps/MapQuestions';
import ReduceAnswers from './steps/ReduceAnswers';
import CreateAggregation from './steps/CreateAggregation';
import Review from './steps/Review';
import SelectScopes from './steps/SelectScopes';
import SelectTopics from './steps/SelectTopics';
import SelectForm from './steps/SelectForm';
import SortInputs from './steps/SortInputs';

const STEPS = {
  CHOOSE_SCOPE: 0,
  SELECT_FORM: 1,

  CHOOSE_TOPICS: 2,
  SELECT_QUESTIONS: 3,

  DIVIDE_FORM: 4,

  MAP_QUESTIONS: 5,
  REDUCE_ANSWERS: 6,
  CREATE_NEW_AGG: 7,
  REVIEW: 8
};

const STRING_FOR_STEP = (i) => {
  if (i === 0) {
    return 'CHOOSE_SCOPE';
  } else if (i === 1) {
    return 'SELECT_FORM';
  } else if (i === 2) {
    return 'CHOOSE_TOPICS';
  } else if (i === 3) {
    return 'SELECT_QUESTIONS';
  } else if (i === 4) {
    return 'DIVIDE_FORM';
  } else if (i === 5) {
    return 'MAP_QUESTIONS';
  } else if (i === 6) {
    return 'REDUCE_ANSWERS';
  } else if (i === 7) {
    return 'CREATE_NEW_AGG';
  } else if (i === 8) {
    return 'REVIEW';
  }
};

const STEP_COMPS = [SelectScopes, SelectForm, SelectTopics, SortInputs, DivideForm, MapQuestions, ReduceAnswers, CreateAggregation, Review];

const PHOTO_AGG_MAPPING = {
  aggType: 'value_at_random',
  name: 'photo',
  mappings: []
};

const NAME_AGG_MAPPING = {
  aggType: 'modal_name_aggregator',
  name: 'name',
  mappings: []
};

export { STEPS, STRING_FOR_STEP, PHOTO_AGG_MAPPING, NAME_AGG_MAPPING, STEP_COMPS };
